module.exports = __webpack_public_path__ + "static/media/murilo-bahia-GxFw4_pKMN8-unsplash.1530b03c.jpg";